import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { CHANGE_FONT } from "../store/types/font";
import { generateRandomNumber } from "../utils";

export const useRandomFont = () => {
  const dispatch = useDispatch();
  const location = useLocation()
  const navigate = useNavigate()
  const { allPairs } = useSelector((state) => state.font);

  const link1randomIndex = generateRandomNumber(allPairs);
   useEffect(() => {
    if (allPairs.length === 0) return;
    dispatch({ type: CHANGE_FONT, payload: [] });
    const query = new URLSearchParams(location.search);
    if (query.get("fontPair1") && query.get("fontPair2")) {
      dispatch({
        type: CHANGE_FONT,
        payload: [query.get("fontPair1"), query.get("fontPair2")],
      });
      return;
    } else {
      const url = `?fontPair1=${allPairs[link1randomIndex]?.likedPair[2]}&fontPair2=${allPairs[link1randomIndex]?.likedPair[3]}`
      if(!sessionStorage.getItem("url")) sessionStorage.setItem("url", url)
      navigate(sessionStorage.getItem("url"))
    }
  }, [dispatch, allPairs, location]);

  return;
};
